var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-col',{staticClass:"pa-0",attrs:{"cols":"12"}},[_c('v-alert',{staticClass:"text-caption font-weight-medium text-center",attrs:{"color":"#ebedf0","dense":""}},[_vm._v(" "+_vm._s(_vm.sLabel)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }